//
// AxisGridDisplay.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var AxisGridDisplay = {
    AUTO_ON:0,
    AUTO_OFF:1,
    ON:2,
    OFF:3
};
export default AxisGridDisplay;
